import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="novelty-toggle"
// Drives the FToggle segmented-button groups in the HR novelty drawers (e.g. "Completas / Parciales").
// Keeps a hidden input in sync with the chosen value and shows/hides any dependent panels.
export default class extends Controller {
  static targets = ["input", "button", "panel"]

  connect() {
    this.select(this.inputTarget.value, false)
  }

  choose(event) {
    this.select(event.currentTarget.dataset.value, true)
  }

  select(value, dispatchChange) {
    this.inputTarget.value = value

    this.buttonTargets.forEach((btn) => {
      btn.classList.toggle("is-active", btn.dataset.value === value)
    })

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.value !== value)
    })

    if (dispatchChange) this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
